// roomdesignerData = { reference: 'pim1234', data: ['pim123', 'pim234']  }

import VueI18n from "vue-i18n";
import Vue from "vue";
import globalRoomdesignerSelection from '@global/global-elements/global-roomdesigner/global-roomdesigner-selection.vue';

export const globalRoomdesignerUtilities = {
    openRoomdesigner(roomdesignerData) {
        document.dispatchEvent(new CustomEvent('selectRoomdesigner', {detail: roomdesignerData}))
    },
    getUrl() {
        if (!window.roomdesignerUrl) {
            return null;
        }

        let url = window.roomdesignerUrl;

        url += 'locale=';
        switch (window.market) {
        case 'DACH':
            url += 'de';
            break;
        case 'FR':
            url += 'fr';
            break;
        case 'NL':
            url += 'nl';
            break;
        case 'IT':
            url += 'it';
            break;
        case 'CZ':
            url += 'cs';
            break;
        case 'Nordics':
            url += 'sv';
            break;
        case 'UK':
            url += 'en_GB';
            break;
        case 'AUS':
            url += 'en';
            break;
        case 'CHN':
            url += 'zh';
            break;
        default:
            url += 'en';
        }

        return url + '&favourites=';
    },
    init() {
        const globalRoomdesignerShell = document.querySelector('.global-roomdesigner-selection');

        if (globalRoomdesignerShell !== null && window.ROOMDESIGNER_L18N) {
            Vue.use(VueI18n)

            new Vue({
                render: h => h(globalRoomdesignerSelection, {
                    props: {}
                }),
                i18n: new VueI18n({
                    locale: 'lang', // set locale
                    messages: window.ROOMDESIGNER_L18N // set locale messages
                }),
            }).$mount(globalRoomdesignerShell);
        } else {
            console.warn('No .global-roomdesigner-selection container or window.ROOMDESIGNER_L18N not set');
        }
    }
};

